<template>
    <div v-if="client">
        <p class="title is-5">Support</p>
        <!-- tawk code -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Tawk code</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input
                            v-model="client.settings.supportSettings.tawkCode"
                            class="input"
                            type="text"
                        />
                    </p>
                </div>
            </div>
        </div>
        <!-- tawk secret -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Tawk secret</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input
                            v-model="client.settings.supportSettings.tawkSecret"
                            class="input"
                            type="text"
                        />
                    </p>
                </div>
            </div>
        </div>
        <!-- tawk widget id -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Tawk Widget Id</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input
                            v-model="client.settings.supportSettings.tawkWidgetId"
                            class="input"
                            type="text"
                        />
                    </p>
                </div>
            </div>
        </div>
        <!-- support email -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Contacts</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <table class="table is-size-7">
                            <tr>
                                <th>Icon html</th>
                                <th>Url</th>
                                <th>Text</th>
                            </tr>
                            <tr
                                v-for="(link, i) in client.settings.supportSettings.contacts"
                                :key="link.url"
                            >
                                <td>
                                    <input
                                        v-model="link.iconHtml"
                                        class="input is-small support-contact-link"
                                        type="text"
                                    />
                                </td>
                                <td>
                                    <input
                                        v-model="link.url"
                                        class="input is-small support-contact-link"
                                        type="text"
                                    />
                                </td>
                                <td>
                                    <input
                                        v-model="link.text"
                                        class="input is-small support-contact-link"
                                        type="text"
                                    />
                                </td>
                                <td>
                                    <a @click="deleteContact(i)" class="button is-small">del</a>
                                </td>
                            </tr>
                        </table>
                        <a @click="addContact()" class="button is-small">add</a>
                    </div>
                </div>
            </div>
        </div>
        <!-- feedback form -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Feedback form</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input
                                v-model="client.settings.supportSettings.feedbackForm"
                                type="checkbox"
                            />
                        </label>
                    </p>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label"></div>
            <div class="field-body">
                <div class="field is-grouped">
                    <div class="control">
                        <button @click="save" class="button is-primary">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import state from '../../../../state';
import utils from '../../../../utils';
import clientService from '../../../../services/client.service';

export default {
    name: 'client-settings-support',
    data() {
        return {
            client: null
        };
    },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        }
    },
    watch: {
        clientId() {
            this.loadClient();
        }
    },
    async mounted() {
        await clientService.ensure();
        this.loadClient();
    },
    methods: {
        loadClient() {
            this.client = utils.clone(state.clients.getClient(this.clientId));
        },
        addContact() {
            this.client.settings.supportSettings.contacts.push({});
        },
        deleteContact(i) {
            this.client.settings.supportSettings.contacts.splice(i, 1);
        },
        async save() {
            await clientService.save(this.client);
        }
    }
};
</script>
<style lang="scss">
.support-contact-link {
    width: 240px;
}
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/settings/support.vue